<template>
  <div>
    <list-layout
      :can-operate="canOperate"
      :column-default-selected="columnDefaultSelected"
      :columns-all="columnsAll"
      :default-selected="tableDefaultSelectData"
      :get-table-data-func="getTableDataFunc"
      :group-tree-func="groupTreeFunc"
      :in-modal="inModal"
      :refresh="updateTableFlag"
      :route-params="$route.params"
      :table-operation-width="tableOperationWidth"
      :tools-list="toolsList"
      @tableSelectData="getSelectData"
      :apiPermission="groupApiPermission"
      :can-drag-column-width="true"
      :search-type-options="[
        { label: '名称', value: 'name' },
        { label: 'IP 地址', value: 'monitor_address' },
        { label: '所属操作系统', value: 'os' }
      ]"
    >
      <template #leftTool>
        <create-button v-permission="{action: 'service.application.create', effect: 'disabled'}" @click="$refs.inputDrawer.show()">
        </create-button>
      </template>
      <!-- 表格自定义列 -->
      <template #name="{ slotProps }">
        <a-tooltip placement="topLeft" :title="slotProps.text">
          <a @click="$refs.detailDrawer.show(slotProps.record.id)" v-if="link">
            {{ slotProps.text }}
          </a>
          <span v-else>{{ slotProps.text }}</span>
        </a-tooltip>
      </template>
      <template #os="{ slotProps }">
        <a-tooltip placement="topLeft" :title="slotProps.text.name">
          <a @click="$refs.osDrawer.show(slotProps.text.id)" v-if="link">
            {{ slotProps.text.name }}
          </a>
          <span v-else>{{ slotProps.text.name }}</span>
        </a-tooltip>
      </template>
      <template #statusTitle>
        <status-question-icon></status-question-icon>
      </template>
      <template #status="{ slotProps }">
        <source-status-tag :status="slotProps.text"></source-status-tag>
      </template>

      <template #serviceTarget="{ slotProps }">
        <a-tooltip v-if="slotProps.text" placement="topLeft" :title="slotProps.text">{{ slotProps.text }}</a-tooltip>
        <span v-else>{{ slotProps.text }}</span>
      </template>
      <template #invocationMode="{ slotProps }">
        <a-tooltip v-if="slotProps.text" placement="topLeft" :title="slotProps.text">{{ slotProps.text }}</a-tooltip>
        <span v-else>{{ slotProps.text }}</span>
      </template>
      <template #dataExchangeContent="{ slotProps }">
        <a-tooltip v-if="slotProps.text" placement="topLeft" :title="slotProps.text">{{ slotProps.text }}</a-tooltip>
        <span v-else>{{ slotProps.text }}</span>
      </template>
      <template #dataExchangePeriod="{ slotProps }">
        <a-tooltip v-if="slotProps.text" placement="topLeft" :title="slotProps.text">{{ slotProps.text }}</a-tooltip>
        <span v-else>{{ slotProps.text }}</span>
      </template>

      <template #operation="{ slotProps }">
        <sync-button @click="sync(slotProps.record.id)"></sync-button>
        <a-dropdown>
          <a-button
            icon="more"
            size="small"
            type="link"
            style="color: #faad14"
          >
            更多
          </a-button>
          <a-menu slot="overlay">
            <a-menu-item key="edit">
              <edit-button v-permission="{action: 'service.application.update', effect: 'disabled'}" @click="$refs.inputDrawer.show(slotProps.record.id, false)"></edit-button>
            </a-menu-item>
            <a-menu-item key="clone">
              <clone-button @click="$refs.inputDrawer.show(slotProps.record.id, true)"></clone-button>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        <delete-button v-permission="{action: 'service.application.delete', effect: 'disabled'}" @confirm="confirm(slotProps.record.id)"></delete-button>
      </template>
    </list-layout>

    <application-drawer ref="detailDrawer"></application-drawer>
    <os-drawer ref="osDrawer"></os-drawer>
    <input-drawer ref="inputDrawer" @ok="confirm"></input-drawer>
  </div>
</template>

<script>
import {
  createApplicationGroup,
  deleteApplication,
  deleteApplicationGroup,
  getApplicationGroup,
  getApplicationGroupList,
  getApplicationList,
  syncApplication,
  updateApplicationGroup
} from '@/api/application'
import ListLayout from '@/components/ListLayout'
import DeleteButton from '@/components/button/DeleteButton'
import CreateButton from '@/components/button/CreateButton'
import EditButton from '@/components/button/EditButton'
import CloneButton from '@/components/button/CloneButton'
import SyncButton from '@/components/button/SyncButton'
import StatusQuestionIcon from '@/components/icon/StatusQuestionIcon'
import SourceStatusTag from '@/components/tag/SourceStatusTag'
import { sourceStatuses } from '@/utils/const'
import { hasPermission } from '@/utils'

export default {
  name: 'ApplicationTable',
  components: {
    ApplicationDrawer: () => import('@/components/drawer/ApplicationDrawer.vue'),
    CloneButton,
    DeleteButton,
    EditButton,
    InputDrawer: () => import('./modules/InputDrawer.vue'),
    ListLayout,
    'os-drawer': () => import('@/components/drawer/OSDrawer'),
    SourceStatusTag,
    StatusQuestionIcon,
    SyncButton,
    CreateButton
  },
  props: {
    defaultSelected: {
      type: Array
    },
    toolsList: {
      type: Array,
      default: () => []
    },
    tableOperationWidth: {
      type: Number,
      default: 240
    },
    link: {
      type: Boolean,
      default: true
    },
    refresh: {
      type: Boolean
    },
    canOperate: {
      type: Boolean,
      default: true
    },
    inModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      getTableDataFunc: getApplicationList,
      columnsAll: [
        {
          dataIndex: 'name',
          title: '名称',
          fixed: 'left',
          width: 200,
          ellipsis: true,
          scopedSlots: {
            customRender: 'name'
          }
        },
        {
          dataIndex: 'os',
          title: '所属操作系统',
          width: 200,
          ellipsis: true,
          scopedSlots: {
            customRender: 'os'
          }
        },
        {
          dataIndex: 'os.monitor_address',
          title: 'IP 地址',
          width: 160,
          scopedSlots: {
            customRender: 'monitorAddress'
          }
        },
        {
          dataIndex: 'version',
          title: '版本',
          width: 120,
          ellipsis: true,
          scopedSlots: {
            customRender: 'version'
          }
        },
        {
          dataIndex: 'status',
          width: 100,
          slots: {
            title: 'statusTitle',
            name: '状态'
          },
          scopedSlots: {
            customRender: 'status'
          },
          filters: sourceStatuses.map(value => {
            return {
              text: this.$t(`source_status.${value}`),
              value
            }
          }),
          filterMultiple: false
        },
        {
          dataIndex: 'created_at',
          title: '创建时间',
          width: 200
        },
        {
          dataIndex: 'updated_at',
          title: '更新时间',
          width: 200
        },
        {
          dataIndex: 'description',
          title: '职能',
          width: 200,
          ellipsis: true,
          scopedSlots: {
            customRender: 'description'
          }
        },
        {
          dataIndex: 'service_target',
          title: '服务对象',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'serviceTarget'
          }
        },
        {
          dataIndex: 'invocation_mode',
          title: '调用模式',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'invocationMode'
          }
        },
        {
          dataIndex: 'data_exchange_content',
          title: '数据同步内容',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'dataExchangeContent'
          }
        },
        {
          dataIndex: 'data_exchange_period',
          title: '数据同步周期',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'dataExchangePeriod'
          }
        }
      ],
      columnDefaultSelected: [
        'name',
        'os',
        'os.monitor_address',
        'version',
        'description',
        'status'
      ],
      updateTableFlag: this.refresh,
      tableSelectData: [],
      tableDefaultSelectData: [],
      groupApiPermission: {
        create: 'service.application_group.create',
        edit: 'service.application_group.update',
        delete: 'service.application_group.delete'
      }
    }
  },
  computed: {
    groupTreeFunc () {
      if (hasPermission(['service.application_group.view'])) {
        return {
          createFunc: createApplicationGroup,
          deleteFunc: deleteApplicationGroup,
          getFunc: getApplicationGroup,
          getListFunc: getApplicationGroupList,
          updateFunc: updateApplicationGroup
        }
      } else return null
    }
  },
  mounted () {
    if (this.defaultSelected) this.tableDefaultSelectData = this.defaultSelected
  },
  methods: {
    getSelectData (data) {
      this.tableSelectData = data
      this.$emit('selectedData', data)
    },
    sync (id) {
      syncApplication({ id }).then(res => {
        this.$message.success(res.message)
      })
    },
    async confirm (id = '') {
      if (id) {
        await deleteApplication(id).then(res => {
          this.$message.success(res.message)
        })
        this.tableSelectData.splice(this.tableSelectData.findIndex(item => item.key === id), 1)
        this.tableDefaultSelectData = this.tableSelectData
        this.$emit('selectedData', this.tableSelectData)
      }
      this.updateTableFlag = !this.updateTableFlag
    }
  },
  watch: {
    refresh (v) {
      this.updateTableFlag = v
    }
  }
}
</script>
